module.exports = {
  _init: function () {
    if (window.location.href.indexOf("buy-pods") == -1) {
      APPLICATION.PodConfigurator.modals.createPopup.setupModal("buy-pods");
      this.onConfigureNow();
      this.onPlaceOrder();
    } else {
    }
    this.onChangePods();
    this.onConfirm();
    this.onContinue();
  },

  onConfigureNow: function () {
    $("#configure-now")
      .not(".js-ignore")
      .on("click", () => {
        APPLICATION.PodConfigurator.modals.createPopup.resetModal();
        APPLICATION._APPLICATION.customModal(
          "/pod-configurator/bedrooms?modal=1",
          "PodConfigurator",
          "bedroomsModal"
        );
      })
      .addClass("js-ignore");
  },

  onPlaceOrder: function () {
    $("#place-order")
      .not(".js-ignore")
      .on("click", () => {
        let pods = $("#pods").val();
        APPLICATION.PodConfigurator.modals.createPopup.resetModal();
        APPLICATION._APPLICATION.customModal(
          "/pod-configurator/terms?pods=" + pods,
          "PodConfigurator",
          "terms"
        );
      })
      .addClass("js-ignore");
  },

  onChangePods: function () {
    $("#pods")
      .not(".js-ignore")
      .on("keyup change", function () {
        var pods = parseInt($(this).val() || 0);

        var max = parseInt($(this).attr("max") || 0);
        if (pods > max) {
          pods = max;
        }

        $(this).val(pods);

        var pods_total = pods * parseFloat($("#pods-price").val() || 0.0);

        $("#pods-total").text(
          Number(pods_total).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        );
      })
      .addClass("js-ignore");
  },

  onConfirm: function () {
    $(".js-confirm")
      .not(".js-ignore")
      .click(function () {
        APPLICATION.PodConfigurator.confirm.showTerms();
      })
      .addClass("js-ignore");
  },

  onContinue: function () {
    $("#pod-continue")
      .not(".js-ignore")
      .click(function () {
        $("#pod-form").submit();
      })
      .addClass("js-ignore");
  },
};
